import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import _ from 'lodash';


export interface InputDialogOptions {
    title: string;
    label: string;
    valid: string;
    defaultValue: any;
    placeholder?: string;
}

@Component({
    selector: 'app-input-dialog',
    templateUrl: './input-dialog.component.html',
    styleUrls: ['./input-dialog.component.scss'],
})
export class InputDialog implements OnInit {

    get controls(): { [x: string]: FormControl; } { return this.form.controls as { [x: string]: FormControl; }; }

    form: FormGroup;
    title: string = '';
    label: string = '';
    valid: string;
    placeholder: string;

    get isValid(): boolean { return this.form.valid; }

    constructor(
        protected fb: FormBuilder,
        protected dialogRef: MatDialogRef<InputDialog>,
        @Inject(MAT_DIALOG_DATA) public config: InputDialogOptions
    ) {

        this.title = config.title || '';
        this.label = config.label || '';
        this.valid = config.valid || 'YES';
        this.placeholder = config.placeholder || '';
        this.form = fb.group({
            data: new FormControl(config.defaultValue || '', [Validators.required]),
        });
    }

    ngOnInit() { }

    submit(): void {
        this.dialogRef.close(_.cloneDeep(this.form.value));
    }

    close(): void {
        this.dialogRef.close();
    }
}
